import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

// Placeholder panel — the real query (recent incidents, near misses, expiring
// worker certifications, overdue toolbox talks, scheduled audits, joined by
// site) is filed as a separate structural card. Until that lands the panel
// renders an empty state so no fictional data leaks to tenants. siteId is kept
// in the signature ready for the real query.

const SafetyOverviewPanel = ({ siteId }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-2 overflow-hidden">
      <div className="px-6 py-4 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold text-foreground font-heading">{t('safetyCompliance')}</h3>
            <p className="text-sm text-muted-foreground">{t('safetySubtitle')}</p>
          </div>
          <Button
            variant="outline"
            size="sm"
            iconName="Plus"
            iconPosition="left"
            onClick={() => navigate('/incident-reporting')}
          >
            {t('safetyReportIncident')}
          </Button>
        </div>
      </div>
      <div className="px-6 py-10 text-center">
        <Icon name="ShieldCheck" size={28} className="text-muted-foreground mx-auto mb-2" />
        <p className="text-sm font-medium text-foreground">No safety items to report</p>
        <p className="text-xs text-muted-foreground mt-1">
          Incidents, expiring certifications, and overdue tasks will appear here.
        </p>
      </div>
      <div className="px-6 py-4 bg-muted/30 border-t border-border">
        <button
          onClick={() => navigate('/incident-reporting')}
          className="text-sm text-accent hover:text-accent/80 font-medium flex items-center gap-1"
        >
          {t('safetyViewAll')} <Icon name="ArrowRight" size={14} />
        </button>
      </div>
    </div>
  );
};

export default SafetyOverviewPanel;
